export var PaginationType;
(function (PaginationType) {
    PaginationType["lines"] = "lines";
    PaginationType["dots"] = "dots";
})(PaginationType || (PaginationType = {}));
//# sourceMappingURL=PaginationType.js.map